import React, { Component } from 'react';
import { Table, Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import {
  datasetPagination,
  getNumberFromTo,
} from '../../../../../scripts/pagination';
import { HeaderTableInvoiceTourTransaction } from '../../constant/HeaderTable';
import Loader from '../../../../../components/loader/loaderInModal';
import moment from 'moment';
import Pagination from '../../../../../components/common/pagination';
class TableInvoiceTourTransaction extends Component {
  constructor(props) {
    super(props);
    this.currentIndex = 0;
    this.state = {
      searchInput: '',
      activePage: 1,
      pageLength: 3,
    };
  }
  static propTypes = {
    data: PropTypes.array,
  };
  handleChange = (e, { name, value }) =>
    this.setState({ [name]: value, activePage: 1 });
  pageChange = (e, { activePage }) => {
    this.setState({ activePage });
  };
  render() {
    let pagedData = datasetPagination(this.props.listData, 3);
    let listData = pagedData[this.state.activePage - 1];
    const props = this.props;

    let { numbersFrom, numbersTo } = getNumberFromTo(
      listData,
      this.state.activePage,
      3
    );
    return (
      <div>
        <Loader loading={props.loading} />
        <Table basic="very" selectable fixed>
          <Table.Header>
            <Table.Row>
              {HeaderTableInvoiceTourTransaction.map(
                (headTableContent, index) => {
                  return (
                    <Table.HeaderCell key={index}>
                      {headTableContent}
                    </Table.HeaderCell>
                  );
                }
              )}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {listData ? (
              listData.map((data, idx) => {
                return (
                  <Table.Row key={idx}>
                    <Table.Cell>{data.Code}</Table.Cell>
                    <Table.Cell>{data.TourTransactionId}</Table.Cell>
                    <Table.Cell>{props.typePackage}</Table.Cell>
                    <Table.Cell>
                      {' '}
                      {moment(data.CreatedDate).format('DD MMM YYYY')}
                    </Table.Cell>
                    <Table.Cell>
                      {' '}
                      {moment(data.LastModifiedDate).format('DD MMM YYYY')}
                    </Table.Cell>
                    <Table.Cell>
                      {new Intl.NumberFormat('de-DE').format(data.Amount)}
                    </Table.Cell>
                    <Table.Cell>
                      {new Intl.NumberFormat('de-DE').format(data.PaidAmount)}
                    </Table.Cell>
                    <Table.Cell>
                      <Button
                        content="Print"
                        primary
                        onClick={props.printInvoice}
                        id={data.TourTransactionId}
                        value={data.Code}
                      />
                    </Table.Cell>
                  </Table.Row>
                );
              })
            ) : (
              <Table.Row>
                <Table.Cell colSpan="8" textAlign="center">
                  No Data
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
        {/* {pagedData &&
            pagedData.length > 1 && (
              <Table.Footer> */}
        <Pagination
          // totalPages={pagedData.length}
          // onPageChange={this.pageChange}
          // activePage={this.state.activePage}
          pagedData={pagedData}
          numbersTo={numbersTo}
          numbersFrom={numbersFrom}
          data={props.listData}
          pageChange={this.pageChange}
          activePage={this.state.activePage}
        />
        {/* </Table.Footer>
            )} */}
      </div>
    );
  }
}

TableInvoiceTourTransaction.propTypes = {
  listData: PropTypes.array,
  handleChoose: PropTypes.func,
  loadingGetUserByCode: PropTypes.bool,
  loading: PropTypes.bool,
  printInvoice: PropTypes.func,
  typePackage: PropTypes.string,
};
export default TableInvoiceTourTransaction;
